const API_URL = '/api';

const createFunctions = () => {
    let cachedUser;

    const fetchFromApi = async (method, url, body, { params, user } = {}) => {
        try {
            const result = await fetch(`${API_URL}/${url}${params ? `?${serialise(params)}`: ''}`, { 
                method,
                headers: await createHeaders(user),
                body: JSON.stringify(body),
            });
            if (result.status >= 400) {
                throw { message: `Request failed: ${result.statusText}`, result }
            }
            return await result.json();
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
    
    const serialise = params => {
        return Object.getOwnPropertyNames(params)
            .map(param => encodeURIComponent(param) + "=" + encodeURIComponent(params[param]))
            .join('&');
    }
    
    const createHeaders = async (user = cachedUser) => {
        return {
            'Authorization': `Bearer ${await user.getIdToken()}`,
            'Content-Type': 'application/json',
        };
    }

    return {
        get: (url, options) => fetchFromApi('GET', url, undefined, options),
        post: (url, body, options) => fetchFromApi('POST', url, body, options),
        put: (url, body, options) => fetchFromApi('PUT', url, body, options),
        delete: (url, options) => fetchFromApi('DELETE', url, undefined, options),
        patch: (url, body, options) => fetchFromApi('PATCH', url, body, options),
        setUser: user => cachedUser = user,
    }
}

export default createFunctions();
